import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { LoadingIcon } from "../../../themes/userq/Loader/loadingIcon";
import { Icon } from "../../../themes/userq/Icon/Icon";
import { Text } from "../../../themes/userq/Text/Text";
import { FilterButtons } from "../../../themes/userq/FilterButtons/FilterButtons";
import { Button } from "../../../themes/userq/Button/Button";
import { Input } from "../../../themes/userq/Input/Input";
import { addLikertScaleService } from "../../../../services/test";
import { ReactSession } from "../../../../lib/secure_reactsession";
import { showError } from "../../../../lib/helpers";
import { ToastMessage } from "../ToastMessage/ToastMessage";

export default function CustomLikertScaleModal({
    open,
    close,
    cssClass,
    scale_options,
    disableCross,
    onUpdate,
    rtl
}) {
    let { test_id } = useParams();

    const [options, setOptions] = useState(["","","","",""]);

    const [scale_length, setScaleLength] = useState(5);
 
    const [formErrors, setFormErrors] = useState({options:[null, null, null,null,null]});

   
    const closeModal = () => {
        close();
    };

    const wrapperRef = useRef(null);

    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (
                    ref.current &&
                    !ref.current.contains(event.target) &&
                    !ref.current.contains(event.target) &&
                    !event.target.classList.contains("onfido-backdrop-shadow")
                ) {
                    if (event.target.nodeName == "DIV") {
                        if (!disableCross) {
                            closeModal();
                        }
                    }
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    useOutsideAlerter(wrapperRef);
    const [customlikertScaleLength, setCustomLikertScaleLength] =
        useState("5 points");

    useEffect(()=>{

        if(open){
           

            setOptions(scale_options);

            
            setScaleLength(scale_options.length == 7 ? 7: 5 );

            var options_errors = [];

            options_errors.forEach(function(option) {
                options_errors.push(null);
            });

            setFormErrors({options:options_errors})
        }
    },[open, scale_options])
    
    const validatePoint = (point, point_index)=>{

        var form_errors = {...formErrors};
        
        if(!formErrors.options){
            var option_errors = [];
            options.forEach(function(option){
                option_errors.push(null);
            });

            form_errors = { options:option_errors};
        }
        options.forEach(function(option, index){
            if(index < point_index  && option.trim()==point.trim() ){
                form_errors.options[point_index] = "You've entered duplicate labels. Please make sure each option is different.";
            }
        });
        setFormErrors(form_errors);
    }
    const validateFullForm = ()=>{
        var error = false;

        var option_errors = [];

        options.forEach(function(option){
            option_errors.push(null);
        });

        var form_errors = { options:option_errors};
        
        var already_options = [];

        options.forEach(function(option, index){
            if(!option){
                form_errors.options[index] = "Required field";
                error = true;
            } else {
                if(already_options.includes(option.trim())){
                    form_errors.options[index] = "You've entered duplicate labels. Please make sure each option is different.";
                    error = true;
                } else {
                    already_options.push(option.trim());
                }
            }
        });
        if(error){
            setFormErrors(form_errors);
        }
        return error;
    }
    const checkBtnState = ()=>{
        var error = false;

        var already_options = [];

            options.forEach(function(option){
                if(!option){
                    error = true;
                } else {
                    if(already_options.includes(option.trim())){
                        error = true;
                    } else {
                        already_options.push(option.trim());
                    }
                }
            });
        

        return !error;
    }
    const submitHandler = (e)=>{
        e.preventDefault();

        var error = validateFullForm();

        if(!error){

            onUpdate(options)
        }
    }

    return (
        <Modal
            show={open}
            centered
            className={`fade custom-modal-wrap   confirmation-modal-wrap help-modal-wrap full-modal custom-scale-modal  ${cssClass}`}
            
        >
            <Modal.Body className="" ref={wrapperRef}>
                
                <div className="modal-inner-text"
                    onClick={(e)=>{e.stopPropagation(); e.preventDefault();}}
                >
                    <div className="modal-header-top mob-mb-60">
                        <div className="d-flex tab-column heading-row">
                            <Text type={"h3"} fontWeight={"bold-font"}>
                                Customise your scale
                            </Text>
                        </div>

                        <button
                            type="button"
                            className="close"
                            onClick={() => {
                                closeModal();
                            }}
                            aria-label="Close"
                        >
                            <span aria-hidden="true">
                                <Icon
                                    value="Close"
                                    size="medium"
                                    hover={true}
                                />
                            </span>
                        </button>
                    </div>

                    
                    <div className={`scalebuttonbox mt-20 ${rtl?'rtldirection':''} `}>
                        <span>Scale length</span>
                        <FilterButtons
                            options={["5 points", "7 points"]}
                            selected={function(){
                                if(scale_length==5){
                                    return "5 points";
                                }
                                return "7 points";
                            }()}
                            onChange={(value) => {
                                if(value=="5 points"){
                                    setScaleLength(5);

                                    if(options.length==7){
                                        setOptions((prevItems) => prevItems.slice(0, Math.max(prevItems.length - 2, 0)));
                                    }
                                } else {
                                    setScaleLength(7);

                                    if(options.length==5){
                                        setOptions((prevItems) => [...prevItems, "", ""]);
                                    }
                                }
                                
                            }}
                        />
                    </div>
                    <div className="col-12 p-0 custom-likert-scale-form mt-20">
                        {options.map(function(option, index){
                            return (
                                <div className="mb-20">
                                    <Input
                                        label={"Point "+(index+1)}
                                        value={option}
                                        maxLength={30}
                                        hideMaxChars={true}
                                        id={"scale_option"+index}
                                        clearField={false}
                                        required={true}
                                        onChange={(e)=>{
                                            let options_loc  = [...options];

                                            options_loc[index] = e.target.value;

                                            setOptions(options_loc);

                                            let form_errors  = [...formErrors.options];

                                            form_errors[index] = null;

                                            setFormErrors({...formErrors, options: form_errors});
                                        }}
                                        error={formErrors.options[index]}
                                        rtl={rtl}
                                        autocomplete={"off"}
                                        onBlur={(e)=>{
                                            validatePoint(e.target.value, index);
                                        }}
                                    />
                                </div>
                            )        
                        })}
                        
                    </div>
                    <div className="mt-32">
                        <ToastMessage
                            icon={"error"}
                            colorClass={"secondary-purple-200-svg"}
                            type={"info"}
                            cssClasses={"gray"}
                            message={
                                <>
                                    <Text
                                        type={"caption"}
                                        fontWeight={"medium-font"}
                                    >
                                        Please note this custom scale will be
                                        saved for this question only.
                                    </Text>
                                </>
                            }
                            closable={false}
                        />
                    </div>
                    <div className={`confirm-buttons-div button-wrap d-flex mt-32  ${rtl?'justify-content-end':''}`}>
                        <Button
                            type="secondary"
                            size={"large"}
                            aria-label="Close"
                            label={"Cancel"}
                            onClick={(e)=>{closeModal();}}
                        />

                        <Button
                            type="primary"
                            className="button primary-btn"
                            aria-label="Close"
                            label={"Save"}
                            size={"large"}
                            cssclass={"ml-32"}
                            state={checkBtnState()?"active":"disabled"}
                            onClick={submitHandler}
                        />
                    </div>
                </div>
                
            </Modal.Body>
        </Modal>
    );
}
